import NotificationFactory from "../../../../../shared/Notifications";
import {toaster} from "rsuite";

export class SensorBlockUtils {

  static handleCopyClick = async (coordinates: string | null) => {
    if (!coordinates) {
      toaster.push(
        NotificationFactory.error("Нет координат для копирования"),
        { placement: "topEnd" }
      );
      return;
    }

    try {
      await navigator.clipboard.writeText(coordinates);
      toaster.push(
        NotificationFactory.success("Координаты скопированы в буфер обмена"),
        { placement: "topEnd" }
      );
    } catch (err) {
      console.error("Ошибка при копировании: ", err);
      toaster.push(
        NotificationFactory.error("Не удалось скопировать координаты"),
        { placement: "topEnd" }
      );
    }
  };

}
